import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import swal from "sweetalert";

//lookup
export const getLookupList = (item) => {
    let url = `${API.lookupsearch}?LookUpToSearch=${item.LookUpToSearch}&LookUpName=${item.LookUpName}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getLookupListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getLookupListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postLookupDetails = (data, type,t) => {
  /*  if (type===TypeofPort && data.lookUpValue!== "") {
        let url1 = `${API.portExist}?name=${this.state.portName}`; 
        axios
          .get(url1)
          .then((response) => {
            if (response.data === true) { */
    let url = `${API.postlookup}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                let searchData = {
                    LookUpToSearch: type === "Flag" ? "flag" : type === "Interval" ? "intervals" : type === "Category" ? "category" /* : type === "Class" ? "class" */ : type === "TypeofShip" ? "typeofship"  : type === "Unit"? "unit": type === "Zone"
                    ? "zone"/* :type === "TypeofPort" ? "typeofport" */: "equipmentType",
                    LookUpName: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                dispatch(getLookupList(searchData));
                toast.success(t('CommonText.CommonAdd'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                /*  } else if (response.data === false) {
                    swal(
                      "Error!",
                      "Port Type already exist. Please change the type",
                      "warning"
                    );
                 dispatch({
                    type: "LookupValue",
                    data: false,
                })
                  } */
                dispatch({
                    type: "postLookupDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postLookupDetailFailure",
                    error: "ERROR"
                })
            })
    }
/* }
    else{
        let url = `${API.postlookup}`;
        return dispatch => {
            axios.post(url, data)
                .then((response) => {
                    let searchData = {
                        LookUpToSearch: type === "Flag" ? "flag" : type === "Interval" ? "intervals" : type === "Category" ? "category" : type === "Class" ? "class" : type === "TypeofShip" ? "typeofship" :type === "TypeofPort" ? "typeofport": "equipmentType",
                        LookUpName: "",
                        PageNumber: 1,
                        PageSize: 20
                    }
                    dispatch(getLookupList(searchData));
                    toast.success('Added Successfully', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                  
                    dispatch({
                        type: "postLookupDetailSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "postLookupDetailFailure",
                        error: "ERROR"
                    })
                })
        }
    } */
}
export const putLookupDetails = (data, type,t) => {
    let url = `${API.postlookup}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                let searchData = {
                    LookUpToSearch: type === "Flag" ? "flag" : type === "Interval" ? "intervals" : type === "Category" ? "category" /* : type === "Class" ? "class" */ : type === "TypeofShip" ? "typeofship" : type === "Unit"? "unit": type === "Zone"
                    ? "zone"/* :type === "TypeofPort" ? "typeofport" */: "equipmentType",
                    LookUpName: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                dispatch(getLookupList(searchData));
                toast.success(t('CommonText.CommonUpdate'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                dispatch({
                    type: "putLookupDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putLookupDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteLookupDetails = (data, type,t) => {
   
    let url = `${API.postlookup}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                let searchData = {
                    LookUpToSearch:type==="misc"?"misc": type === "Flag" ? "flag" : type === "Interval" ? "intervals" :  type === "Unit" ? "unit": type === "Zone" ? "zone":type === "Category" ? "category"  : type === "Class" ? "class"  : type === "TypeofShip" ? "typeofship"/*  : type === "TypeofPort" ? "typeofport" */ :"equipmentType",
                    LookUpName: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                toast.success(t('CommonText.CommonDelete'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                dispatch(getLookupList(searchData));
                dispatch({
                    type: "deleteLookupDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteLookupDetailFailure",
                    error: "ERROR"
                })
            })
    }
}

//Flag
export const getFlagSearchList = (item) => {
    let url = `${API.flagSearch}?Country=${item.Country}&Mail=${item.Mail}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getFlagSearchListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getFlagSearchListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getFlagApplicableService = (id) => {
    let url = `${API.flagApplicableServices}?flagId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getFlagApplicableServiceSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getFlagApplicableServiceFailure",
                    error: "ERROR"
                })
            })
    }
}

export const postFlagDetails = (data) => {
    let url = `${API.postFlag}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                let searchData = {
                    Country: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                dispatch(getFlagSearchList(searchData));
                dispatch({
                    type: "postFlagDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postFlagDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putFlagDetails = (data) => {
    let url = `${API.postFlag}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                let searchData = {
                    Country: "",
                    PageNumber: 1,
                    PageSize: 20
                }
                dispatch(getFlagSearchList(searchData));
                dispatch({
                    type: "putFlagDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putFlagDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
//MakeModel
export const getMakeSearchList = (item) => {
    let url = `${API.MakeSearch}?Make=${item.Make}&Model=${item.Model}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getMakeSearchListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getMakeSearchListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getServiceTypeUsed = (id) => {
    let url = `${API.ServiceTypeUsed}?serviceTypeId=${id}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getServiceTypeUsedSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getServiceTypeUsedFailure",
            error: "ERROR",
          });
        });
    };
  };

  //class
  export const getClassSearchList = (item) => {
    let url = `${API.lookupsearch}?LookUpToSearch=${item.LookUpToSearch}&LookUpName=${item.LookUpName}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getClassSearchListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClassSearchListFailure",
                    error: "ERROR"
                })
            })
    }
}
  export const getClassApplicableService = (id) => {
    let url = `${API.getClassAopplicableService}?classId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getClassApplicableServiceSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClassApplicableServiceFailure",
                    error: "ERROR"
                })
            })
    }
}
//Misc

export const getMiscSearchList = (item) => {
    let url = `${API.lookupsearch}?LookUpToSearch=${item.LookUpToSearch}&LookUpName=${item.LookUpName}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getMiscSearchListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getMiscSearchListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const getMiscApplicableService = (id) => {
    let url = `${API.getMiscApplicableService}?miscId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getMiscApplicableServiceSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getMiscApplicableServiceFailure",
                    error: "ERROR"
                })
            })
    }
}